import { QSetStatus } from '@report/graphql';
import { parseAsInteger, useQueryStates, parseAsStringEnum, parseAsString } from 'nuqs';

export function useQuestionUsageByQSetReportSearchParams() {
  const [{ qSetStatus, examCourse, page, pageSize }, setQueryParams] = useQueryStates({
    examCourse: parseAsString.withDefault(''),
    qSetStatus: parseAsStringEnum(Object.values(QSetStatus)),
    page: parseAsInteger.withDefault(0),
    pageSize: parseAsInteger.withDefault(50),
  });

  const changeFilterParams = (params: {
    examCourse: string;
    qSetStatus: QSetStatus | null;
    page: number;
    pageSize: number;
  }) => {
    setQueryParams(params);
  };

  const changePage = (page: number) => {
    setQueryParams({ page });
  };
  const changePageSize = (pageSize: number) => {
    setQueryParams({ page: 0, pageSize });
  };

  return [
    {
      qSetStatus,
      examCourse,
      page,
      pageSize,
    },
    {
      changeFilterParams,
      changePage,
      changePageSize,
    },
  ] as const;
}
